export class FormBundleCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSchema() {
    return this.#http.get('/api/pos-configurations/form-bundle-criteria/schema');
  }
}
